<template>
  <div class="h-100">
    <div class="loader-cont" v-dxloader="isLoader"></div>
    <div class="row h-100" v-show="!isLoader">
      <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
      <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
        <div class="container">
          <div class="row">
            <div class="col s10 m6 l6 alignLeft">
              <h5 class="card-title alignLeft white-text">Sub Admin</h5>
            </div>
            <div class="col s10 m6 l6 alignRight">
              <a
                @click="preAdd()"
                data-target="modal-service"
                class="btn modal-trigger add_btn mb-1 waves-effect waves-light"
              >
                <span>Add Subadmin</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 p-0" style="height:calc(100% - 52px)">
        <div class="container p-0 h-100">
          <div class="section p-0 h-100">
            <div class="row m-0 h-100">
              <div class="col s12 m12 l12 p-0 h-100">
                <div id="responsive-table" class="card card card-default scrollspy mb-0 h-100">
                  <div class="card-content h-100">
                    <div class="row">
                      <div class="search-input col s8 m5 l5">
                        <div class="sidebar-search animate fadeUp pb-0">
                          <div class="search-area">
                            <i class="material-icons mr-2 search-icon">search</i>
                            <i
                              class="material-icons mr-2 close-icon"
                              v-show="filters.search"
                              @click="filters.search=''"
                            >close</i>
                            <input
                              type="text"
                              v-model="filters.search"
                              placeholder="Search"
                              class="app-filter"
                              id="chat_filter"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-2" style="height: calc(100% - 100px);overflow-y: auto;">
                      <div class="col s12 subadmin h-100">
                        <table class="responsive-table" v-if="subAdminList.length > 0">
                          <thead>
                            <tr>
                              <th data-field="index">S.No</th>
                              <th data-field="id">Name</th>
                              <th data-field="name">Mobile Number</th>
                              <th data-field="price">Email</th>
                              <th data-field="status">Action</th>
                              <th data-field="status">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(admin,index) in subAdminList"
                              :key="index"
                              @click="setCurrentId(admin)"
                            >
                              <td>{{index+1}}.</td>
                              <td>{{admin.first_name}}</td>
                              <td>{{admin.mobile_number}}</td>
                              <td>{{admin.email}}</td>
                              <td>
                                <a
                                  @click="selectUser(admin)"
                                  data-target="modal-service"
                                  class="modal-trigger btn-floating mb-1 waves-effect waves-light"
                                  title="Edit"
                                >
                                  <i class="material-icons">edit</i>
                                </a>
                                <a
                                  @click="preResetPassword()"
                                  id="modalpassword"
                                  data-target="modal-password"
                                  class="modal-trigger btn-floating mb-1 waves-effect waves-light"
                                  title="Reset Password"
                                >
                                  <i class="material-icons">lock</i>
                                </a>
                                <a
                                  v-if="!admin.is_active"
                                  @click="onResentEmail(admin)"
                                  class="resend_btn btn-floating mb-1 waves-effect waves-light"
                                  title="Resend Verification Email"
                                >
                                  <i class="material-icons">mail_outline</i>
                                </a>
                              </td>
                              <td>
                                <div class="switch">
                                  <label>
                                    <input
                                      :id="'toggle' + index"
                                      :name="'toggle' + index"
                                      v-model="admin.is_active"
                                      @change="onStatusChange($event,admin)"
                                      type="checkbox"
                                    />
                                    <span class="lever"></span>
                                  </label>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="modal-service" class="modal mo-40">
      <div class="modal-header header_br">
        <h6 class="alignLeft">{{isEdit ? 'Update' : 'Add'}} SubAdmin</h6>
      </div>
      <form class="login-form">
        <div class="modal-content">
          <div class="row">
            <div class="col s12 m12 l12">
              <div class="row margin-model">
                <div class="input-field col s12">
                  <input maxlength="50" v-model="currUser.name" id="name" name="name" type="text" />
                  <label for="name" class="center-align">Full Name</label>
                </div>
                <div class="input-field col s12">
                  <input
                    @keyup="mobileErr=''"
                    v-number-only
                    minlength="10"
                    maxlength="10"
                    v-model="currUser.mobile"
                    id="mobile"
                    name="mobile"
                    type="text"
                  />
                  <label for="mobile" class="center-align">Mobile Number</label>
                  <div class="error-message" v-if="mobileErr">{{mobileErr}}</div>
                </div>
                <div class="input-field col s12 pack-ta" :class="{'error-ta' : !currUser.email}">
                  <input
                    :disabled="isEdit"
                    @keyup="emailErr=''"
                    v-model="currUser.email"
                    id="email"
                    name="email"
                    type="text"
                  />
                  <label for="email" class="center-align">Email</label>
                  <div class="error-message" v-if="emailErr">{{emailErr}}</div>
                </div>
                <div class="input-field col s12">
                  <select
                    @change="errorMessage=''"
                    multiple
                    id="permissions"
                    name="permissions"
                    v-model="currUser.permissions"
                  >
                    <option
                      v-for="item in permissions"
                      :key="item.id"
                      :value="item.id"
                    >{{item.name}}</option>
                    <option disabled value>Choose Permissions</option>
                  </select>
                  <label>Permissions</label>
                  <div class="error-message" v-if="errorMessage">{{errorMessage}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a class="modal-action modal-close waves-effect btn-flat">Cancel</a>
          <button
            v-loader-button="isLoading"
            @click="submit()"
            type="submit"
            name="action"
            class="pointer waves-effect btn"
          >Save</button>
        </div>
      </form>
    </div>

    <!-- reset password -->
    <div id="modal-password" class="modal mo-40">
      <div class="modal-header header_br">
        <h6 class="alignLeft">Reset Password</h6>
      </div>
      <form class="password-form">
        <div class="modal-content">
          <div class="row">
            <div class="col s12 m12 l12">
              <div class="row margin">
                <div class="input-field col s12">
                  <input
                    @keyup="errorMessage=''"
                    v-model="password.npassword"
                    id="npassword"
                    name="npassword"
                    type="password"
                  />
                  <label for="npassword" class="center-align">New Password</label>
                  <!-- <div class="error-message" v-if="errorMessage">{{errorMessage}}</div> -->
                </div>
                <div class="input-field col s12">
                  <input
                    @keyup="errorMessage=''"
                    v-model="password.cpassword"
                    id="cpassword"
                    name="cpassword"
                    type="password"
                  />
                  <label for="cpassword" class="center-align">Confirm Password</label>
                  <div class="error-message" v-if="errorMessage">{{errorMessage}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a
            class="modal-action modal-close waves-effect btn-flat"
            @click="preResetPassword()"
          >Cancel</a>
          <button
            v-loader-button="isLoading"
            type="submit"
            name="action"
            class="pointer waves-effect btn"
          >Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoader: true,
      errorMessage: "",
      isEdit: false,
      isLoading: false,
      password: {
        npassword: "",
        cpassword: ""
      },
      emailErr: "",
      mobileErr: "",
      currUser: {
        permissions: []
      },
      Validator: {},
      PasswordValidator: {},
      subAdminList: [],
      permissions: [],
      filters: {
        search: ""
      },
      currentId: ""
    };
  },
  created() {
    setTimeout(() => {
      $(".modal").modal({ dismissible: false });
    }, 500);

    setTimeout(() => {
      var thisObj = this;
      this.Validator = $(".login-form").validate({
        rules: {
          name: {
            required: true
          },
          email: {
            required: true,
            email: true
          },
          mobile: {
            required: true,
            minlength: 10,
            maxlength: 10
          },
          permissions: {
            required: true
          }
        },
        errorElement: "div",
        errorPlacement: function(error, element) {
          var placement = $(element).data("error");
          if (placement) {
            $(placement).append(error);
          } else {
            error.insertAfter(element);
          }
        },
        submitHandler: e => {
          setTimeout(() => {
            thisObj.errorMessage = "";
            if (thisObj.currUser && thisObj.currUser.permissions.length == 0) {
              thisObj.errorMessage = "Please select at least one permission";
            } else {
              if (!thisObj.emailErr && !this.mobileErr) {
                if (thisObj.isEdit) {
                  this.confirmUpdateSubAdmin();
                } else {
                  this.addSubAdmin();
                }
              }
            }
          }, 300);
          return false;
        }
      });
      this.PasswordValidator = $(".password-form").validate({
        rules: {
          npassword: {
            required: true,
            minlength: 6
          },
          cpassword: {
            required: true,
            minlength: 6,
            equalTo: "#npassword"
          }
        },
        messages: {
          cpassword: {
            equalTo: "Passwords does not match"
          }
        },
        errorElement: "div",
        errorPlacement: function(error, element) {
          var placement = $(element).data("error");
          if (placement) {
            $(placement).append(error);
          } else {
            error.insertAfter(element);
          }
        },
        submitHandler: e => {
          setTimeout(() => {
            if (!thisObj.isLoading) {
              thisObj.resetPassword();
            }
          }, 300);
          return false;
        }
      });
    }, 500);
    this.listSubAdmin();
    this.listPermissions();
  },
  methods: {
    listSubAdmin(url = Constants.default.APIURL.SubAdmin) {
      return new Promise(resolve => {
        ajax.get(
          url,
          res => {
            this.subAdminList = res.data;
            this.isLoader = false;
            if (this.subAdminList.length == 0) {
              Vue.showNoDataBlock(".subadmin");
            } else {
              Vue.hideNoDataBlock(".subadmin");
            }
            resolve(true);
          },
          err => {
            this.isLoader = false;
            resolve(false);
          }
        );
      });
    },
    listPermissions(url = Constants.default.APIURL.SubAdminPermissions) {
      return new Promise(resolve => {
        ajax.get(
          url,
          res => {
            this.permissions = res.data;
            setTimeout(() => {
              $("select").formSelect();
            }, 200);
            resolve(true);
          },
          err => {
            resolve(false);
          }
        );
      });
    },
    preAdd() {
      this.currUser = {
        permissions: []
      };

      this.isEdit = false;
      this.errorMessage = "";
      this.emailErr = "";
      this.mobileErr = "";
      setTimeout(() => {
        $("select").formSelect();
        this.Validator.resetForm();
        M.updateTextFields();
      }, 100);
    },
    addSubAdmin() {
      return new Promise((resolve, reject) => {
        let permissionArr = [];
        this.currUser.permissions.forEach(val => {
          permissionArr.push({ permission_id: val });
        });
        this.isLoading = true;
        ajax.post(
          Constants.default.APIURL.SubAdmin,
          {
            first_name: this.currUser.name,
            mobile_number: this.currUser.mobile,
            email: this.currUser.email,
            permissions: permissionArr
          },
          res => {
            this.isLoading = false;
            Vue.toast("Subadmin was added sucessfully.");
            $(".modal").modal("close");
            this.listSubAdmin();
            resolve();
          },
          err => {
            this.isLoading = false;
            this.handleError(err);
            reject();
          }
        );
      });
    },
    confirmUpdateSubAdmin() {
      return new Promise((resolve, reject) => {
        let query = {
          id: this.currUser.id,
          first_name: this.currUser.name,
          mobile_number: this.currUser.mobile,
          email: this.currUser.email,
          updated_permissions: this.currUser.permissions
        };
        this.isLoading = true;
        ajax.patch(
          Constants.default.APIURL.SubAdmin + this.currUser.id + "/",
          query,
          res => {
            Vue.toast("Subadmin was updated sucessfully.");
            this.isLoading = false;
            $(".modal").modal("close");
            this.listSubAdmin();
            resolve();
          },
          err => {
            this.isLoading = false;
            this.handleError(err);
            reject();
          }
        );
      });
    },
    deActivatePackage(id) {
      return new Promise(resolve => {
        ajax.delete(
          Constants.default.APIURL.SubAdmin + id + "/",
          {},
          res => {
            resolve(true);
          },
          err => {
            resolve(false);
          }
        );
      });
    },
    onStatusChange(e, subAdminOpt) {
      let toggle = subAdminOpt.is_active;
      setTimeout(() => {
        e.target.checked = !e.target.checked;
        subAdminOpt.is_active = !subAdminOpt.is_active;
      }, 0);
      swal({
        title: "Are you sure?",
        text: `Do you want to ${!toggle ? "disable" : "enable"} this subadmin`,
        icon: "warning",
        dangerMode: !toggle,
        buttons: {
          cancel: true,
          delete: `Yes, ${!toggle ? "Disable" : "Enable"}`
        }
      }).then(async willDelete => {
        if (willDelete) {
          let result = await this.deActivatePackage(subAdminOpt.id);
          if (result) {
            e.target.checked = !e.target.checked;
            subAdminOpt.is_active = e.target.checked;
          }
        }
      });
    },

    setCurrentId(admin) {
      this.currentId = admin.id;
    },
    selectUser(admin) {
      this.isEdit = true;
      this.emailErr = "";
      this.errorMessage = "";
      this.mobileErr = "";
      this.currUser = {
        id: admin.id,
        name: admin.first_name,
        mobile: admin.mobile_number,
        email: admin.email,
        permissions: []
      };
      admin.permissions.forEach(val => {
        this.currUser.permissions.push(val.permission.id);
      });
      setTimeout(() => {
        $("select").formSelect();
        this.Validator.resetForm();
        M.updateTextFields();
      }, 100);
    },
    preResetPassword() {
      this.errorMessage = "";
      this.password = {
        npassword: "",
        cpassword: ""
      };
      setTimeout(() => {
        this.PasswordValidator.resetForm();
        M.updateTextFields();
      }, 100);
    },
    resetPassword() {
      return new Promise(resolve => {
        let query = {
          password: this.password.npassword
        };
        this.isLoading = true;
        ajax.patch(
          Constants.default.APIURL.SubAdmin +
            this.currentId +
            "/" +
            "reset_password/",
          query,
          res => {
            this.isLoading = false;
            Vue.toast("Password was updated sucessfully.");
            $(".modal").modal("close");
            this.preResetPassword();
            resolve(true);
          },
          err => {
            this.isLoading = false;
            Vue.toast("", err);
            resolve(false);
          }
        );
      });
    },
    handleError(err) {
      let errorMessage = "";
      if (err.status == 400) {
        if (err.data) {
          if (err.data.non_field_errors) {
            errorMessage = err.data.non_field_errors[0];
            Vue.toast(errorMessage);
          } else {
            if (Object.keys(err.data).length > 0) {
              this.emailErr = err.data["email"] ? err.data["email"][0] : "";
              this.mobileErr = err.data["mobile_number"]
                ? err.data["mobile_number"][0]
                : "";
            }
          }
        } else {
          if (err.non_field_errors) {
            errorMessage = err.non_field_errors[0];
            Vue.toast(errorMessage);
          } else {
            if (Object.keys(err).length > 0) {
              if (Object.keys(err.data).length > 0) {
                this.emailErr = err.data["email"] ? err.data["email"][0] : "";
                this.mobileErr = err.data["mobile_number"]
                  ? err.data["mobile_number"][0]
                  : "";
              }
            }
          }
        }
        errorMessage = errorMessage ? errorMessage : "Something went wrong.";
      } else if (err.status == 401) {
      } else {
      }
    },
    submit() {
      this.errorMessage = "";
      if (this.currUser && this.currUser.permissions.length == 0) {
        this.errorMessage = "Please select at least one permission";
      }
    },
    resendEmail(id) {
      return new Promise(resolve => {
        ajax.post(
          Constants.default.APIURL.SubAdmin + id + "/resend-activation-mail/",
          {},
          res => {
            Vue.toast("The Verification mail was sent successfully.");
            resolve(true);
          },
          err => {
            resolve(false);
          }
        );
      });
    },
    onResentEmail(subAdminOpt) {
      swal({
        title: "Are you sure?",
        text: `Do you want to resent the verification email?`,
        icon: "info",
        dangerMode: false,
        buttons: {
          cancel: "No",
          delete: `Yes`
        }
      }).then(willDelete => {
        if (willDelete) {
          this.resendEmail(subAdminOpt.id);
        }
      });
    },
    searchFilter(filter) {
      let url = Constants.default.APIURL.SubAdmin;
      url += filter.search ? "?q=" + filter.search : "";
      this.listSubAdmin(url);
    }
  },
  watch: {
    filters: {
      handler: function() {
        this.searchFilter(this.filters);
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.add_category {
  float: right;
  .add_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -7px;
  }
}
#modalpassword {
  margin-left: 8px;
  display: inline-block;
}
.btn-floating {
  color: #212121;
  background: white !important;
  margin-right: 5px;
  i {
    color: #212121 !important;
  }
}
.margin-model {
  margin: 0;
}
.error-message {
  text-align: right;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
a.add_btn {
  margin-top: 10px;
  margin-right: 10px;
  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.resend_btn {
  margin-left: 8px;
}
.search-input {
  .sidebar-search {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    padding: 0 0 1rem 0;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  .search-area {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    width: -webkit-calc(100% - 0rem);
    width: -moz-calc(100% - 0rem);
    width: calc(100% - 0rem);
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
  i {
    font-size: 1.45rem;
    height: 41px;
    margin-right: 0 !important;
    padding: 0.75rem 0.25rem 0.35rem 0.75rem;
    color: #9e9e9e;
    border-radius: 5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    background-color: #eceff1;
  }
  .app-filter {
    height: 35px;
    margin-bottom: 0;
    padding: 0.2rem;
    color: #183247;
    border: none;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background-color: #eceff1;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border-bottom: 0 !important;
    box-shadow: none !important;
  }
}
.search-area {
  i.close-icon {
    position: absolute;
    right: 10px;
    cursor: pointer;
    font-size: 18px;
    top: 22px;
    height: inherit;
    padding: 0;
    line-height: 0;
  }
}
.responsive-table {
  &.card-content {
    padding: 16px 24px;
  }
}
</style>
